// extracted by mini-css-extract-plugin
export default {"container":"EmailNotification_container__jGf4C","description":"EmailNotification_description__VTdcv","email":"EmailNotification_email__quNDT"};